module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp23_8004.58f5d3a9.png";